export default __webpack_public_path__ + "static/media/consult.d7229336.png";